import { render } from "./PhoneNumber.vue?vue&type=template&id=7db1c795"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts"

import "./PhoneNumber.vue?vue&type=style&index=0&id=7db1c795&lang=css"
script.render = render

export default script